import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

const POINTS = [
  "White-glove intake & authentication",
  "Exposure to 50,000+ active collectors",
  "You set reserves, we run the sale",
  "Fast payouts after items sell",
];

export default function ConsignTeaser() {
  const navigate = useNavigate();
  return (
    <section
      id="consign"
      data-testid="consign-teaser"
      className="relative bg-[#0a0a0b] py-24 md:py-32 border-t border-white/10 overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-20 right-0 h-[460px] w-[460px] rounded-full bg-[#3FE1D1]/10 blur-[150px]" />
      <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <span className="text-xs uppercase tracking-[0.3em] text-[#3FE1D1] font-medium">
              Consignment Program
            </span>
            <h2 className="mt-5 font-display font-extrabold uppercase tracking-tighter text-white text-4xl md:text-6xl lg:text-7xl leading-[0.9]">
              Turn your <br />
              collection <span className="text-[#3FE1D1]">into cash.</span>
            </h2>
            <p className="mt-6 text-white/60 text-base md:text-lg leading-relaxed max-w-lg">
              Sitting on grails? Send them in. We put your pieces in front of
              50,000+ buyers across Whatnot, TikTok and eBay — you set the reserve,
              we handle the sale, authentication and shipping.
            </p>
            <button
              data-testid="consign-teaser-cta"
              onClick={() => navigate("/consign")}
              className="group mt-9 inline-flex items-center gap-2 bg-[#3FE1D1] text-[#050505] font-bold uppercase text-sm tracking-[0.14em] px-8 py-4 hover:bg-white transition-colors duration-200"
            >
              Start Your Consignment
              <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-5 lg:col-start-8"
          >
            <ul className="space-y-5 border-l border-[#3FE1D1]/40 pl-8">
              {POINTS.map((t) => (
                <li key={t} className="flex items-start gap-3 text-white/80 text-base md:text-lg">
                  <span className="mt-0.5 h-6 w-6 flex-shrink-0 bg-[#3FE1D1]/15 border border-[#3FE1D1]/40 flex items-center justify-center">
                    <Check size={13} className="text-[#3FE1D1]" />
                  </span>
                  {t}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
